export const theme = {
  light: 'light',
  dark: 'dark',
};

export const selectGender = {
  0: '선택',
  1: '여자',
  2: '남자',
};